import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const Booking = () => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [bookingData, setBookingData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchbookingData = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getBookingDetail}`);
            if (response.status === 200) {
                setBookingData(response?.data?.data)
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchbookingData();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = bookingData.filter(item =>
                item.Name.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.MobileNo.toString().includes(searchTerm)
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(bookingData);
        }
    }, [searchTerm, bookingData]);

    const handleStatusChange = async (row, e) => {
        try {
            const response = await axios.post(`${baseurl}${API_URL?.updateBookingStatus}`, {
                loginId: row?.LoginId,
                bookingId: row?.BookingId,
                status: e.target.value,
                deviceToken: row?.DeviceToken
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.status === 200) {
                toast.success("Booking status updated successfully.");
                fetchbookingData();
            }
        } catch (error) {
            toast.error("Error updating booking status. Please try again later.");
        }
    };

    const onBookingDetailByLoginId = (row) => {
        navigate(`/booking-detail/${row?.LoginId}`);
    }

    const columns = [
        {
            name: 'SR.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Name',
            selector: row => row.Name,
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="booking_data curser-pointer" onClick={() => onBookingDetailByLoginId(row)}>
                    <h6>{row.EmailId}</h6>
                    <span>{row?.MobileNo}</span>
                </div>
            ),
            sortable: true,
            minWidth: '300px'
        },
        // {
        //     name: 'Slot Time',
        //     selector: row => row?.Slot,
        //     sortable: true,
        //     minWidth: '100px'
        // },
        {
            name: 'Appoiment Date',
            selector: row => {
                if (row.SlotDate) {
                    const date = new Date(row.SlotDate);

                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0');
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: false,
            minWidth: '130px'
        },
        {
            name: 'Status',
            selector: row => (
                <>
                    <div>
                        {/* {(row.BookingStatus === "N") && ( */}
                        <div className="button_status d-flex">
                            <select
                                className="form-group"
                                value={row.BookingStatus}
                                onChange={(e) => handleStatusChange(row, e)}
                            >
                                {row?.BookingStatus !== "C" || row?.BookingStatus !== "R" &&
                                    <option value="N">Not Confirmed</option>
                                }
                                <option value="C">Confirmed</option>
                                <option value="R">Rejected</option>
                            </select>
                        </div>
                        {/* )} */}
                        {/* {(row.BookingStatus === "R") && (
                            <div className="rejected_btn">
                                <button>Rejected</button>
                            </div>
                        )}
                        {(row.BookingStatus === "C") &&
                            <div className="confirmed_btn">
                                <button>Confirmed</button>
                            </div>
                        } */}
                    </div>

                </>
            ),
            sortable: false,
            minWidth: '150px'
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Booking</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    {/* <button
                            className={`status_filter ${activeButton === 'canceled' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('canceled')}
                        >
                            Canceled
                        </button>
                    </div>
                    <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button> */}
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
            </div>


        </Layout>
    )
}

export default Booking;